<section class="streaming-wrap box" id="streamingWrap" *ngIf="showStreamingComponent">
    <div class="close" (click)="close()">
        <i class="icon icon-cross"></i>
    </div>
    <app-streaming *ngIf="!isWidgetActive" [url]="liveStreamUrl"></app-streaming>
    <app-streaming-widget *ngIf="isWidgetActive && streamingEventBetradarEventId" [betRadarEventId]="streamingEventBetradarEventId" [isFullSize]="isWidgetFullSize"></app-streaming-widget>
    <div class="buttons" *ngIf="streamingEventLiveStreamId && isUserLoggedIn">
        <span class="btn small" [class.active]="!isWidgetActive" (click)="switchWidgetAndLiveStream(false)">
            <i class="sporticon sporticon-play icon-xs text-info"></i>
        </span>
        <span class="btn small" [class.active]="isWidgetActive" (click)="switchWidgetAndLiveStream(true)">
            <span class="fields {{getSportName(sportId)}}"></span>
            <!-- <i class="sporticon sporticon-stadium icon-xs text-success"></i> -->
        </span>
    </div>
</section>
